import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout, Breadcrumb, Form, Input, DatePicker, Radio, Modal,
  Select, Switch, Button, Table, message, notification,
  Skeleton, InputNumber, List, Divider, Avatar
} from 'antd';
import { EyeOutlined, BookOutlined, UploadOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import _ from 'lodash';
import styles from './styles.module.scss';
import whttp from '../../libs/whttp';
import { API_HOST, Role, GOOGLE_MAP_KEY } from '../../configs/env';
import AppHelper from 'libs/AppHelper';
import CitySelect from 'components/CitySelect/CitySelect';
import WUpload, { AvatarUpload } from 'components/WUpload/WUpload';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton'
import { genFormItemAtrribute } from 'libs/FormHelper'
import Validator from 'validatorjs';
import Errors from 'validatorjs/src/errors';
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert';
import moment from 'moment';

const Option = Select.Option;

const cardBodyStyle = { padding: 8, fontSize: 8 }
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4, }

@DragDropContext(HTML5Backend)
export default class VendorInfo extends Component {
  formRef = React.createRef();
 
  state = {
    recipeInfo: {
      id     : null,
      status : 1,
      name   : null,
      logo   : null,
      type   : 1,
      ingredients : [{},{}]
    },
    data: [],
    messages: {},
    isFetchData: false,
    isSubmitData: false,
  }
  
  componentDidMount() {

    AppHelper.updateConfig()

    this.fetchData()
    
  }

  fillData = (data = _.cloneDeep(devVendorInfo)) => {

    if (!this.formRef.current) return

    // 處理資料，本地適合Form Control的資料
    if (!_.isString(data.image)) 
    {
      data.image= null
    } else {
      data.image = {
        id: 1,
        path: data.image,
        url : data.image_url,
      }
    } 
    
    if (!_.isBoolean(data.status)) data.status = data.status === 1

    this.formRef.current.setFieldsValue(data)
  }
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this,'props.match.params.id')
    
    if (!id) return;

    this.setState({ isFetchData: true })
    whttp.get(API_HOST + `/api/mgt/v1/vendors/${id}`, null,
      (state, res) => {
        this.setState({ isFetchData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res)
        
        if (state === false || code !== 200) { 
          message.warning(reason)
          this.props.history.replace('/vendors')
          return 
        }

        this.fillData(data)
        
      })
  }
  submitData = (recipeInfo={}) => {
    // 把Control元件轉換回上傳資料
    recipeInfo.image = _.get(recipeInfo,'image.path')
    const current_user = _.get(window, 'VC_CONFIG.WP_CURRENT_USER', '')
    recipeInfo.user_id = current_user.ID
    const id = _.get(this, 'props.match.params.id', '')

    this.setState({ isSubmitData: true, messages: {} })
    
    whttp.post(API_HOST + `/api/mgt/v1/vendors/${id}`, recipeInfo,
      (state, res) => {
        console.log(state, res)
        this.setState({ isSubmitData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) { return message.error('發生錯誤'); }

        if (code !== 200) {

          notification['error']({
            message: '更新失敗',
            description: reason,
          });
          const messages = data.messages
          if (_.isObject(messages)) {
            //處理錯誤訊息
            _.map(messages, (errors, key) => {
              console.log('map', key, errors)
              return {
                touched: true,
                validating: false,
                errors: [],
                name: [key],
                value: this.getFieldValue(key)
              }
            })
            this.forceUpdate()
            console.log('this.formRef.current', this.formRef.current)
          }
          return this.setState({ messages: data.messages || {} });
        }
        
        const { data: { id: new_id } = {} } = res

        if (new_id != id) {
          message.success('新增成功')
          this.setState({ recipeInfo: data });
          
          return this.props.history.replace(`/vendors/view/${new_id}`);
        }

        message.success('更新成功')

      })
  }
  
  deleteUser = (e) => {
    const id = _.get(this, 'props.match.params.id')

    if (!id) return;

    this.setState({ isDeleteUser: true })
    whttp.delete(API_HOST + `/api/mgt/v1/vendors/${id}`, {
    }, (state, res) => {

      this.setState({ isDeleteUser: false })
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) { return message.error('發生錯誤'); }

      if (code !== 200) { return message.error(reason); }

      notification['success']({
        message: '刪除成功'
      });

      return this.props.history.replace(`/vendors`);
    });
  }
  getImages = () => {
    return this.formRef.current && _.isArray(this.formRef.current.getFieldValue('images')) ? this.formRef.current.getFieldValue('images') : []
  }
  moveRow = (dragIndex, hoverIndex) => {
    const { table_data = {}, table_data: { rows = [] } = {} } = this.state;
    let images = this.getImages()
    const dragRow = images[dragIndex];

    images = update(images, { $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],})

    this.formRef.current.setFields([
      {
        touched: true,
        validating: false,
        errors: [],
        name: ['images'],
        value: images
      }
    ])
  } 

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current ? this.formRef.current.getFieldValue(key) : defaultValue
  }

  enterNotSubmit = (e) =>{
    if(e.key === 'Enter') {
      let value = e.target + "";
      if(value.indexOf("TextArea") !== -1){console.log('TextArea')}
      else e.preventDefault();
    }
  }

  render() {

    // 登入使用者的權限
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const editorPermissions = _.get(this.props, 'auth.permissions', {})
    const options = _.get(this,'props.app.options',{})
    const pdf = this.getFieldValue('pdf')
    return (
      <Layout className={styles.container}>

        <Breadcrumb>
          <Breadcrumb.Item><Link to={`/vendors`}>第三方平台管理</Link></Breadcrumb.Item>
          <Breadcrumb.Item>第三方平台資訊</Breadcrumb.Item>
        </Breadcrumb>

        <h2>第三方平台資訊</h2>

        <ValidatorErrorAlert errors={errors} />

        <Skeleton loading={this.state.isFetchData}>
          <div className="block search">
            <Form 
              ref={this.formRef}
              name="basic"
              className='basicForm'
              layout="vertical"
              onFinish={values => this.submitData(values) }
              onValuesChange={(changedFields, allFields) => console.log('onValuesChange', changedFields)}
              onKeyDown={(e) => {this.enterNotSubmit(e)}}
            >
              <Form.Item style={{ textAlign: 'right' }} taillayout={{ wrapperCol: { offset: 8, span: 16 } }}>
                <Button type="primary" htmlType="submit" style={{ marginLeft: 8 }}
                  loading={this.state.isSubmitData} >儲存</Button>
              </Form.Item>
              
              <div className='flexBox'>
                <Form.Item {...genFormItemAtrribute('name', '名稱')} rules={[{ required: true, message: '請填寫名稱' }]}><Input /></Form.Item>
              
                <Form.Item
                  {...genFormItemAtrribute('type', '平台類別')}
                  rules={[{ required: true, message: '請選擇類別' }]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {_.map(_.get(options, 'vendor_types', []), item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                  </Select>
                </Form.Item>
              </div>

              <Form.Item
                {...genFormItemAtrribute('image', '圖片 寬1110x高370')}
                style={{ minHeight: 166 }}
              >
                <AvatarUpload />
              </Form.Item>

            </Form>
          </div>
                 
          <Modal visible={this.state.previewImage} footer={null} onCancel={() => this.setState({ previewImage: null })}>
            <img alt="Preview" style={{ width: '100%' }}
              src={this.state.previewImage && this.state.previewImage.url} />
          </Modal>
        </Skeleton>
      </Layout>
    );
  }
}

const devVendorInfo = {
  name:'3皇3家', 
  type:1, 
  desc:null, 
  sort:null, 
  logo:null, 
  pdfs:[],
  images: []
}


/* DnD */
let dragingIndex = -1;


class BodyRow extends React.Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props;
    const style = { ...restProps.style, cursor: 'move' };

    let className = restProps.className;
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward';
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward';
      }
    }

    return connectDragSource(
      connectDropTarget(
        <tr
          {...restProps}
          className={className}
          style={style}
        />
      )
    );
  }
}

const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index;
    return {
      index: props.index,
    };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

const DragableBodyRow = DropTarget(
  'row',
  rowTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }),
)(
  DragSource(
    'row',
    rowSource,
    (connect) => ({
      connectDragSource: connect.dragSource(),
    }),
  )(BodyRow),
);

/* DnD */


// WEBPACK FOOTER //
// ./src/views/Vendor/VendorInfo.js